(function () {
  'use strict';

  if (window.S10ConfiguratorEmbed) return;
  window.S10ConfiguratorEmbed = true;

  var NAMESPACE = 's10-configurator';
  var CONTACT_FORM_ID = 's10-configurator-contact';
  var CONTACT_FRAME_NAME = 's10-configurator-contact-target';

  function originOf(url) {
    try {
      return new URL(url, window.location.href).origin;
    } catch (error) {
      return '';
    }
  }

  function sectionForSource(source) {
    return Array.prototype.find.call(
      document.querySelectorAll('[data-configurator]'),
      function (section) {
        var iframe = section.querySelector('iframe');
        return iframe && iframe.contentWindow === source;
      }
    );
  }

  function readCookie(name) {
    var prefix = name + '=';
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < cookies.length; i += 1) {
      if (cookies[i].indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(cookies[i].slice(prefix.length));
        } catch (error) {
          return cookies[i].slice(prefix.length);
        }
      }
    }
    return '';
  }

  function privacy() {
    return (window.Shopify && window.Shopify.customerPrivacy) || {};
  }

  function marketingAllowed() {
    if (typeof privacy().marketingAllowed !== 'function') return false;
    return privacy().marketingAllowed() === true;
  }

  function analyticsAllowed() {
    if (typeof privacy().analyticsProcessingAllowed !== 'function') return false;
    return privacy().analyticsProcessingAllowed() === true;
  }

  function sendHostContext(iframe, origin) {
    if (!iframe || !iframe.contentWindow || !origin) return;

    var params = new URLSearchParams(window.location.search);
    var attribution = window.S10Attribution ? window.S10Attribution.get() : {};
    var firstTouch = window.S10Attribution ? window.S10Attribution.getFirstTouch() : {};
    var allowMarketing = marketingAllowed();
    var allowAnalytics = analyticsAllowed();

    iframe.contentWindow.postMessage(
      {
        namespace: NAMESPACE,
        type: 'host-context',
        context: {
          pageUrl: window.location.href,
          referrer: document.referrer,
          fid: params.get('fid') || attribution.fid || '',
          marketingConsent: allowMarketing,
          analyticsConsent: allowAnalytics,
          attribution: attribution,
          firstTouch: firstTouch,
          fbp: allowMarketing ? readCookie('_fbp') : '',
          fbc: allowMarketing ? readCookie('_fbc') : '',
          gaClientId: allowAnalytics ? readCookie('_ga') : '',
        },
      },
      origin
    );
  }

  function publicPayload(payload) {
    var blocked = { email: 1, phone: 1, name: 1, company: 1, body: 1 };
    var out = {};
    Object.keys(payload || {}).forEach(function (key) {
      if (!blocked[key]) out[key] = payload[key];
    });
    return out;
  }

  function definedParams(source, keys) {
    var out = {};
    keys.forEach(function (key) {
      if (source[key] !== undefined && source[key] !== null && source[key] !== '') {
        out[key] = source[key];
      }
    });
    return out;
  }

  function publishConfiguratorEvent(name, rawPayload) {
    var payload = publicPayload(rawPayload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 's10_' + name }, payload));

    if (payload.google_event) {
      window.dataLayer.push(
        Object.assign(
          {
            event: payload.google_event,
            event_id: payload.event_id,
            lead_source: payload.lead_source || '3d-configurator',
          },
          definedParams(payload, [
            'value',
            'currency',
            'content_name',
            'content_ids',
            'content_type',
            'variant_id',
            'submission_id',
          ])
        )
      );
    }

    if (payload.google_ads_event && payload.google_ads_event !== payload.google_event) {
      window.dataLayer.push(Object.assign({ event: payload.google_ads_event }, payload));
    }

    if (typeof fbq === 'function' && payload.meta_event) {
      var metaParams = definedParams(payload, [
        'value',
        'currency',
        'content_name',
        'content_ids',
        'content_type',
        'content_category',
      ]);
      var metaOptions = payload.event_id ? { eventID: payload.event_id } : undefined;
      if (payload.meta_method === 'trackCustom') {
        fbq('trackCustom', payload.meta_event, metaParams, metaOptions);
      } else {
        fbq('track', payload.meta_event, metaParams, metaOptions);
      }
    }
  }

  function setContactField(form, name, value) {
    var field = form.querySelector('[name="' + name + '"]');
    if (!field) return;
    field.value = value || '';
  }

  var activeContact = null;
  var acceptedContacts = new Set();

  function submitShopifyContact(payload, source, origin, requestId) {
    var form = document.getElementById(CONTACT_FORM_ID);
    var dialog = document.getElementById('s10-configurator-verification');
    var target = dialog && dialog.querySelector('iframe');
    var status = document.querySelector('[data-s10-contact-status]');
    function reply(success, error) {
      source.postMessage({ namespace: NAMESPACE, type: 'shopify_contact_result',
        requestId: requestId, success: success, error: error || '' }, origin);
    }
    if (!form || !target || !payload || !payload.email || !payload.body) {
      reply(false, 'The Shopify enquiry form is unavailable. Please reload the page.');
      return;
    }
    // Stable submission IDs prevent repeat clicks from sending duplicate enquiries.
    var key = JSON.stringify([payload.submissionId || requestId, payload.email, payload.body]);
    if (acceptedContacts.has(key)) { reply(true); return; }
    if (activeContact) {
      reply(false, 'An enquiry is already being sent. Please wait.');
      return;
    }
    activeContact = key;
    var finished = false;
    var submitted = false;
    var timer;
    var originalParent = form.parentNode;
    var originalNext = form.nextSibling;
    var observer = new MutationObserver(showInlineChallenge);
    function showInlineChallenge() {
      if (finished) return;
      if (form.querySelector('iframe[src*="hcaptcha"], iframe[src*="recaptcha"], .h-captcha, .g-recaptcha')) {
        dialog.querySelector('[data-s10-contact-form-host]').appendChild(form);
        if (!dialog.open) dialog.showModal();
      }
    }
    observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    function finish(success, error) {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      observer.disconnect();
      if (form.parentNode !== originalParent) originalParent.insertBefore(form, originalNext);
      target.hidden = true;
      target.removeEventListener('load', onLoad);
      dialog.removeEventListener('cancel', onCancel);
      dialog.querySelector('[data-s10-contact-cancel]').removeEventListener('click', onCancel);
      if (dialog.open) dialog.close();
      activeContact = null;
      if (success) acceptedContacts.add(key);
      if (status) {
        status.hidden = false;
        status.textContent = success ? 'Your enquiry has been received by Shopify.' : error;
      }
      reply(success, error);
    }
    function onCancel(event) {
      event.preventDefault();
      finish(false, 'Verification was cancelled. Please try again.');
    }
    function onLoad() {
      if (!submitted || finished) return;
      try {
        var url = new URL(target.contentWindow.location.href);
        if (url.href === 'about:blank') return;
        var doc = target.contentDocument;
        if (url.origin === window.location.origin &&
            (url.searchParams.get('contact_posted') === 'true' ||
             doc.querySelector('[data-s10-contact-success]'))) {
          finish(true);
        } else if (url.pathname === '/challenge' || url.pathname.indexOf('/challenge/') === 0) {
          target.hidden = false;
          if (!dialog.open) dialog.showModal();
        } else {
          finish(false, 'Shopify could not confirm your enquiry. Please try again.');
        }
      } catch (error) {
        // An external or blocked verification page must never count as success.
        finish(false, 'Shopify verification could not be displayed. Please try again.');
      }
    }
    target.addEventListener('load', onLoad);
    dialog.addEventListener('cancel', onCancel);
    dialog.querySelector('[data-s10-contact-cancel]').addEventListener('click', onCancel);
    timer = setTimeout(function () {
      finish(false, 'Shopify did not confirm your enquiry in time. Please check before retrying.');
    }, 180000);
    if (status) status.hidden = true;

    setContactField(form, 'contact[email]', payload.email);
    setContactField(form, 'contact[phone]', payload.phone || '');
    setContactField(form, 'contact[body]', payload.body);
    // Shopify follows return_to after accepting the contact submission.
    var returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }
    returnTo.value = window.location.pathname + '?contact_posted=true';
    form.setAttribute('target', CONTACT_FRAME_NAME);
    function send() {
      if (finished || submitted) return;
      // Exclude only extra contact fields; preserve Shopify's own CAPTCHA tokens.
      Array.prototype.forEach.call(form.elements, function (field) {
        if (field.name && field.name.indexOf('contact[') === 0 &&
            ['contact[email]', 'contact[phone]', 'contact[body]'].indexOf(field.name) === -1) {
          field.disabled = true;
        }
      });
      submitted = true;
      try {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      } catch (error) {
        finish(false, 'The enquiry could not be submitted. Please try again.');
      }
    }
    try {
      if (window.Shopify && window.Shopify.captcha &&
          typeof window.Shopify.captcha.protect === 'function') {
        showInlineChallenge();
        window.Shopify.captcha.protect(form, send);
      } else {
        send();
      }
    } catch (error) {
      finish(false, 'Shopify verification could not start. Please reload the page.');
    }
  }

  window.addEventListener('message', function (event) {
    var section = sectionForSource(event.source);
    if (!section) return;

    var iframe = section.querySelector('iframe');
    var origin = originOf(iframe && iframe.src);
    if (!origin || event.origin !== origin) return;

    var data = event.data;
    if (!data || data.namespace !== NAMESPACE) return;

    switch (data.type) {
      case 'ready':
        if (window.S10Attribution && window.S10Attribution.ready) {
          window.S10Attribution.ready.then(function () {
            sendHostContext(iframe, origin);
          });
        } else {
          sendHostContext(iframe, origin);
        }
        break;

      case 'height':
        if (typeof data.height === 'number' && data.height > 0) {
          section.style.setProperty('--s10-configurator-height', data.height + 'px');
        }
        break;

      case 'navigate':
        if (typeof data.url !== 'string') break;
        try {
          var dest = new URL(data.url, window.location.origin);
          var allowed = dest.hostname === 's10home.com' ||
            dest.hostname === 'www.s10home.com' || dest.origin === window.location.origin;
          if (allowed && (dest.protocol === 'https:' || dest.protocol === 'http:')) {
            window.location.href = dest.href;
          }
        } catch (error) {}
        break;

      case 'event':
        publishConfiguratorEvent(data.name, data.payload || {});
        break;

      case 'shopify_contact':
        submitShopifyContact(data.payload || {}, event.source, event.origin, data.requestId);
        break;
    }
  });
})();
